import { Divider, Link, Stack, Typography } from "@mui/material";
import React from "react";
import Exampler1 from "../../files/Quality Assurance/Occupational Certificate Public Sector Auditor Exampler 2025-07-28.pdf";
import Exampler2 from "../../files/Quality Assurance/Occupational Certificate Public Sector Auditor Memo_and_Marking_Grid 2025-07-28.pdf";

const EISA = () => {
  return (
    <Stack spacing={2}>
      <Typography
        fontWeight="bolder"
        fontSize={20}
        sx={{ color: "primary.main", textTransform: "uppercase" }}
      >
        External Integrated Summative Assessment (EISA)
      </Typography>
      <Divider />
      <Typography textAlign="justify">
        Assessment for leaners enrolled in occupational qualifications is
        facilitated through an External Integrated Summative Assessment (EISA).
        SDPs will conduct an Internal Assessment for learners, whereafter they
        will issue the learners with Statement of Results (SoR). The SoRs should
        reflect achievement by learners against the three components of an
        occupational qualification, i.e., Knowledge, Practical Experience, and
        Workplace Experience. EISA’s are conducted through accredited Assessment
        Centres. Registration for EISA can be requested by the SDP or by the
        individual leaner. FASSET will publish a calendar or dates for the
        scheduling of EISAs for all the occupational qualifications with
        learners in the system.
      </Typography>
      <Typography fontWeight="bolder">
        Occupational Certificate: Public Sector Auditor NQF 8 exemplar on the
        website.
      </Typography>
      <ul>
        <li>
          <Typography>
            <Link
              sx={{ textDecoration: "none", cursor: "pointer" }}
              href={Exampler1}
              target="_blank"
            >
              Occupational Certificate Public Sector Auditor Exampler
            </Link>
          </Typography>
        </li>

        <li>
          <Typography>
            <Link
              sx={{ textDecoration: "none", cursor: "pointer" }}
              href={Exampler2}
              target="_blank"
            >
              Occupational Certificate Public Sector Auditor
              Memo_and_Marking_Grid
            </Link>
          </Typography>
        </li>
      </ul>
    </Stack>
  );
};

export default EISA;
